export default {
    SET_TEST_TITLE(store, title) {
        store.testTitle = title
    },
    SET_TEST_CONTENT(store, content) {
        store.testContent = content
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js